<div class="row form">
    <div class="col-lg-12 col-md-12 col-sm-12 col-12">
      <div class="page-title-box form__head">
        <div class="row align-items-center">
          <div class="col-sm-6 col-6">
            <a class="page-title form__head__title" (click)="cancel()">
              <i class="fas fa-arrow-left m-r-5"></i>{{txtSubmenu}} proveedor
            </a>
          </div>
          <div class="col-sm-6 col-6 form__head__boxBtn">
            <p class="m-b-0 m-t-5">Campos requeridos (<span class="required-top">*</span>)</p>
          </div>
        </div>
      </div>
    </div>
  
    <div class="col-lg-12">
      <div class="card m-b-30">
        <div class="card-body">
          <ng-container *ngIf="service_alert.show">
              <div class="alert alert-{{service_alert.class}} alert-dismissible fade show" role="alert">
                <button type="button" class="close" aria-label="Close" (click)="service_alert.show = false">
                    <span aria-hidden="true">×</span>
                </button>
                <strong>¡Datos extraídos!, </strong> {{service_alert.message}}
              </div>
          </ng-container>
          <form validate [formGroup]="item" (ngSubmit)="onSubmit()">
            <div class="row">
              <div class="col-lg-9">
                <div class="row">                  
                  <div class="form-group col-lg-4">
                    <label>N° Documento<span class="required"></span>
                      <ng-container *ngIf="typeDocumentSelected != null">
                        <span class="badge badge-info m-l-15"> {{typeDocumentSelected.max_length_document}} dígitos</span>
                      </ng-container>
                    </label>
                    <div class="input-group" *ngIf="typeDocumentSelected != null">
                      <input type="text" class="form-control" id="client_document" formControlName="document" 
                        maxlength="{{typeDocumentSelected.max_length_document}}" numeric required  autofocus>
                      <div class="input-group-append bg-custom" *ngIf="typeDocumentSelected.id == documentRuc.id">
                        <div class="input-group-text pointer btn-sunat" (click)="extractRuc()" data-toggle="tooltip"
                          data-placement="right" data-original-title="Extraer de Sunat"></div>
                      </div>
                      <div class="input-group-append bg-custom" *ngIf="typeDocumentSelected.id == documentDni.id">
                        <div class="input-group-text pointer btn-reniec" (click)="extractDni()" data-toggle="tooltip"
                          data-placement="right" data-original-title="Extraer de Reniec"></div>
                      </div>
                    </div>
                    <div *ngIf="submitted && f['document'].errors">
                      <small class="text-danger" *ngIf="f['document'].errors['required']">Campo requerido</small>
                    </div>
                  </div>
                  <div class="form-group col-lg-8">
                    <label>Nombre ó Razón Social<span class="required"></span></label>
                    <input type="text" id="client_fullname" class="form-control text-uppercase" formControlName="fullname"
                      required>
                    <div *ngIf="submitted && f['fullname'].errors">
                      <small class="text-danger" *ngIf="f['fullname'].errors['required']">Campo requerido</small>
                    </div>
                  </div>
                  <div class="form-group col-lg-12">
                    <label>Nombre comercial</label>
                    <input type="text" id="client_tradename" formControlName="tradename"
                      class="form-control text-uppercase">
                  </div>
                  <div class="form-group col-lg-4">
                    <label>Departamento <span *ngIf="required_ubigeo" class="required"></span></label>
                    <select class="form-control" [(ngModel)]="departmentSelected" (change)="changeDepartment()"
                      [ngModelOptions]="{standalone: true}">
                      <option value="0">Seleccione</option>
                      <option *ngFor="let item of departments" [value]="item.code">{{ item.name }}</option>
                    </select>
                  </div>
                  <div class="form-group col-lg-4">
                    <label>Provincias<span *ngIf="required_ubigeo" class="required"></span></label>
                    <select class="form-control" [(ngModel)]="provinceSelected" (change)="changeProvince()"
                      [ngModelOptions]="{standalone: true}">
                      <option value="null">Seleccione</option>
                      <ng-container *ngIf="provinces.length > 0">
                        <option *ngFor="let item of provinces" [value]="item.code">{{ item.name }}</option>
                      </ng-container>
                    </select>
                  </div>
                  <div class="form-group col-lg-4">
                    <label>Distritos <span *ngIf="required_ubigeo" class="required"></span></label>
                    <select class="form-control" id="districtSelected" formControlName="ubigeo">
                      <option value="null">Seleccione</option>
                      <ng-container *ngIf="districts.length > 0">
                        <option *ngFor="let item of districts" [value]="item.code">{{ item.name }}</option>
                      </ng-container>
                    </select>
                  </div>
                  <div class="form-group col-lg-12">
                    <label>Dirección</label>
                    <textarea class="form-control no-resize" rows="1" formControlName="address"></textarea>
                  </div>
                  <div class="form-group col-lg-4">
                    <label>Celular</label>
                    <input type="text" class="form-control" formControlName="cellphone">
                  </div>
                  <div class="form-group col-lg-4">
                    <label>Teléfono fijo</label>
                    <input type="text" class="form-control" formControlName="telephone">
                  </div>
                  <div class="form-group col-lg-4">
                    <label>Correo electrónico</label>
                    <input type="email" class="form-control" formControlName="email">
                  </div>
                </div>
              </div>
              <div class="col-lg-3">
                <p class="text-center p-t-15">
                  <ng-container *ngIf="item.value.url_image != null">
                    <img width="200" height="165" src="tenants/{{item.value.url_image}}" alt="Preview">
                  </ng-container>
                  <ng-container *ngIf="item.value.url_image == null">
                    <ng-container *ngIf="imageUrl == null">
                      <img id="output" width="200" src="/images/default.png" />
                    </ng-container>
                    <ng-container *ngIf="imageUrl != null">
                      <img width="200" height="165" [src]="imageUrl" alt="Preview">
                    </ng-container>
                  </ng-container>
                </p>
                <p class="text-center">
                  <label for="file" style="cursor: pointer" class="m-b-0"><i class="fas fa-upload"></i>
                    Seleccionar Imagen 
                    <input id="file" type="file" (change)="onFileSelected($event)" accept=".png, .jpg, .jpeg"
                      style="visibility: hidden;">
                  </label>
                </p>
              </div>
            </div>
            <div class="form-group col-lg-12 form__footerBtn">
              <div class="text-right">
                <a class="btn btn-secondary text-white" (click)="cancel()">Cancelar</a>
                <button type="submit" class="btn btn-primary waves-effect waves-light" [disabled]="item.invalid">
                  <i class="far fa-save m-r-5"></i>
                  Guardar
                  <ng-container *ngIf="isEdit">
                    Cambios
                  </ng-container>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
